/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   VrboPriceAndAvailability Bizo
 */

import type {
  RawVrboPriceAndAvailability,
  VrboPriceAndAvailability as VrboPriceAndAvailabilityType,
} from '@zcode/state-type'

import { Bizo, autoclass } from '../../shared/bizos/base'

const DEFINITION = {
  vrboId: 'Id',
  roomTypes: 'RoomTypes',
  status: 'Status',
  price: (t: VrboPriceAndAvailabilityType) => {
    return t?.roomTypes?.[0]?.Price ?? {}
  },
  links: (t: VrboPriceAndAvailabilityType) => {
    return t?.roomTypes?.[0]?.Links ?? {}
  },
  avgNightlyRate: (t: VrboPriceAndAvailabilityType) => t?.price?.AvgNightlyRate?.Value ?? '',
  baseRate: (t: VrboPriceAndAvailabilityType) => t?.price?.BaseRate?.Value ?? '',
  taxesAndFees: (t: VrboPriceAndAvailabilityType) => t?.price?.TaxesAndFees?.Value ?? '',
  totalPrice: (t: VrboPriceAndAvailabilityType) => t?.price?.TotalPrice?.Value ?? '',
  totalPriceWithPropertyFees: (t: VrboPriceAndAvailabilityType) =>
    t?.price?.TotalPriceWithPropertyFees?.Value ?? '',
  href: (t: VrboPriceAndAvailabilityType) => t?.links?.WebSearchResult?.Href ?? '',
} as const

export const vrboPriceAndAvailability = autoclass<
  VrboPriceAndAvailabilityType,
  RawVrboPriceAndAvailability
>(
  'VrboPriceAndAvailability',
  class VrboPriceAndAvailability extends Bizo<
    VrboPriceAndAvailabilityType,
    RawVrboPriceAndAvailability
  > {},
  DEFINITION,
  null
)
